// Valeurs prédéfinies pour les listes déroulantes

export const ramOptions = [
  '2 Go',
  '4 Go',
  '8 Go',
  '16 Go',
  '32 Go',
  '64 Go',
  '128 Go'
];
export const cpuOptions = [
  '2 cores',
  '4 cores',
  '8 cores',
  '16 cores',
  '32 cores',
  '64 cores'
];
export const diskOptions = [
  '100 Go',
  '200 Go',
  '300Go',
  '500 Go NVMe',
  '1 To NVMe',
  '2 To NVMe'
];
export const osOptions = [
  'Ubuntu 20.04 LTS',
  'Ubuntu 22.04 LTS',
  'Debian 11',
  'Debian 12',
  'CentOS 7',
  'Rocky Linux 8',
  'Rocky Linux 9',
  'Windows Server 2019',
  'Windows Server 2022'
];
export const mariadbVersionOptions = [
  '10.8.8',
  '10.9.8',
  '10.10.5',
  '10.11.2',
  '10.11.4'
];
export const apacheVersionOptions = [
  '2.4.52',
  '2.4.55',
  '2.4.56',
  '2.4.58',
  'N/A'
];
export const nodejsVersionOptions = [
  '14.20.1',
  '16.18.0',
  '18.15.0',
  '18.16.0',
  '20.5.0'
];
// Définition des versions critiques qui nécessitent une mise à jour
export const criticalVersions = {
  mariadb: {
    versions: ['10.8.8', '10.9.8'], // Versions nécessitant une mise à jour
    message: "Version obsolète avec vulnérabilités de sécurité. Mettez à jour vers 10.11.x.",
    level: 'critical' // critical, warning, ou info
  },
  nodejs: {
    versions: ['14.20.1'], // Versions nécessitant une mise à jour
    message: "Version en fin de support. Mettez à jour vers 18.x ou 20.x.",
    level: 'warning'
  },
  apache: {
    versions: ['2.4.52'], // Versions nécessitant une mise à jour
    message: "Version obsolète avec correctifs de sécurité manquants.",
    level: 'warning'
  },
  gitPatientApp: {
    versions: ['v2.10.5', 'v2.14.9'], // Versions des applications nécessitant une mise à jour
    message: "Version obsolète avec des fonctionnalités manquantes.",
    level: 'info'
  },
  gitManagerFrontApp: {
    versions: ['v2.8.3'], 
    message: "Version obsolète. Mise à jour recommandée vers v3.x.",
    level: 'info'
  },
  gitMarshallerVersion: {
    versions: ['v1.7.2'], 
    message: "Version non compatible avec les nouvelles fonctionnalités d'interop.",
    level: 'warning'
  },
  gitMarshallerInteropVersion: {
    versions: ['v0.5.9'], 
    message: "Version obsolète nécessitant une mise à jour.",
    level: 'info'
  }
};

// Fonction utilitaire pour vérifier si une version est critique
export const checkCriticalVersion = (component, version) => {
  if (!version || !criticalVersions[component]) return null;
  
  // Si la version est dans la liste des versions critiques
  if (criticalVersions[component].versions.includes(version)) {
    return {
      message: criticalVersions[component].message,
      level: criticalVersions[component].level
    };
  }
  
  return null;
};
